import React from 'react'

import '@/styles/main.css'

import { DefaultSWRConfig } from '@/common/api/fetcher'

import ConfirmDialogProvider from '@/components/container/modal/dialog/confirm/ConfirmDialogProvider'
import DeleteDialogProvider from '@/components/container/modal/dialog/delete/DeleteDialogProvider'
import PasswordModalProvider from '@/components/container/modal/password/PasswordModalProvider'
import DisclosureProvider from '@/components/container/modules/disclosure/DisclosureProvider'
// import PageAccessAuthWrapper from '@/components/container/page/PageAccessAuthWrapper'
import ToastMessageProvider from '@/components/container/utils/message/ToastMessageProvider'

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <DefaultSWRConfig fallback={{}}>
      <ToastMessageProvider>
        <ConfirmDialogProvider>
          <DeleteDialogProvider>
            <DisclosureProvider>
              <PasswordModalProvider>{children}</PasswordModalProvider>
            </DisclosureProvider>
          </DeleteDialogProvider>
        </ConfirmDialogProvider>
      </ToastMessageProvider>
    </DefaultSWRConfig>
  )
}

export default AppProvider
